module.exports = __webpack_public_path__ + "img/case5.52b8a236.jpg";